import React, { useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import "swiper/css";
import "./Style.css";
import { Autoplay, Navigation } from "swiper";
const Companies = () => {
  const logos = [
    {
      logo: require("../../../../images/solm8LastCh.png"),
      url: "/category/Shoes",
      text: "Pakistan's only Solm8 distributor",
    },
    {
      logo: require("../../../../images/CAPartner.png"),
      url: "/topbrand/2",
      text: null,
    },
    // { logo: require("../../../../images/MillatPartner.png")},
    // { logo: require("../../../../images/MatadorPartner.png")},
  ];
  return (
    <>
      <div className="mainCompanySection mb-5">
        <hr style={{ borderColor: "#808080", margin: "10px 0px" }} />
        <div className="headingSection mt-5">
          <h1>Our Official Partners</h1>
        </div>
        <Swiper
          className="mySwiper"
          style={{ margin: "1.125rem auto 1.125rem auto" }}
          spaceBetween={10}
          autoplay={{
            delay: 6000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          navigation={true} modules={[Navigation, Autoplay]} 
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            420: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 1,
            },
            768: {
               slidesPerView: 2
            },
            900: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 2,
            },
          }}
        >
          {logos.length &&
            logos.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <Link to={item.url}>
                    <img src={item.logo} alt="" loading="lazy" />
                    <p className="subHeadText">{item.text}</p>
                  </Link>
                </SwiperSlide>
              );
            })}
        </Swiper>
        <hr style={{ borderColor: "#808080", margin: "10px 0px" }} />
      </div>
    </>
  );
};

export default Companies;
